import { render, staticRenderFns } from "./NavigationTranslationForm.vue?vue&type=template&id=6cfa6510&"
import script from "./NavigationTranslationForm.vue?vue&type=script&lang=js&"
export * from "./NavigationTranslationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports